import { Button, ButtonProps } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import React from 'react'

export const DropdownItemOptionButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        unstyled
        className={cn(
          'flex h-10 w-full select-none items-center gap-3 whitespace-nowrap rounded px-2 text-sm font-light tracking-wide outline-none hover:bg-neutral-75/75 focus:bg-neutral-75/75 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </Button>
    )
  },
)
